import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createDataReduceObject } from '../../../../../common/reducers/data/reducer';
import taskViewAsExecutorSaga from './sagas/taskViewAsExecutorSaga';

export default [
  ...createCombineMapItem('taskViewAsExecutor', createDataReduceObject, [
    taskViewAsExecutorSaga
  ])
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/reducers/static/views/reducersMap.js